<template>
  <component v-if="pageData"
             :is="currentView"
             :page-data="pageData"
             :sn="sn"
  />
</template>

<script>
  import { commonLog } from '@/services/app';
  import { getAuth, projectJump } from '@/utils';
  import { getNotifyInfo } from '@/services/order';
  import PayNotifyMillionReadExperienceVip from '@/pages/Pay/components/PayNotifyMillionReadExperienceVip';
  import PayNotifyMillionReadVip from '@/pages/Pay/components/PayNotifyMillionReadVip';
  import PayNotifyVip from '@/pages/Pay/components/PayNotifyVip';
  import PayNotifyGift from '@/pages/Pay/components/PayNotifyGift';
  import PayNotifyGeneral from '@/pages/Pay/components/PayNotifyGeneral';
  import PayNotifyExchangeMallShop from '@/pages/Pay/components/PayNotifyExchangeMallShop';
  import { getRequiredUserInfoPageStatus } from '@/services/user';

  export default {
    name: 'PayNotify',
    metaInfo: {},
    components: {
      PayNotifyMillionReadExperienceVip,
      PayNotifyMillionReadVip,
      PayNotifyVip,
      PayNotifyGift,
      PayNotifyGeneral,
      PayNotifyExchangeMallShop,
    },
    data() {
      return {
        currentView: '',
        pageData: null,
      };
    },
    computed: {
      type() {
        return this.$route.query && this.$route.query.type ? this.$route.query.type : '';
      },
      redirectTo() {
        return this.$route.fullPath;
      },
      sn() {
        return this.$route.params.sn;
      },
    },
    methods: {
      fetchPageType(type) {
        switch (type) {
          case 'gift': // 赠送
          case 'giftVip': // 会员赠送
          case 'pointProduct': // 积分兑换
            return 'PayNotifyGift';
          case 'vip': // 会员
            return 'PayNotifyVip';
          case 'audio': // 音频
          case 'course': // 直播课
          case 'audioCombo': // 音频系列
          case 'courseCombo': // 直播课系列
          case 'project': // 线下项目
          case 'exchange': // 单门兑换
          case 'exchange_multi': // 多门兑换
          case 'reading': // 训练营
          case 'learn': // 学习计划
          case 'couponBatch': // 优惠券(暂用于订金)
            return 'PayNotifyGeneral';
          case 'entity': // 实物
            return 'OrderDetail';
          case 'millionVip': // 百万阅读
            return 'PayNotifyMillionReadVip';
          case 'millionVipPreSale': // 百万阅读预售
            return 'millionVipPreSale';
          case 'coinProduct': // 熊熊币商城兑换通知
            return 'PayNotifyExchangeMallShop';
          default: {
            commonLog('PayNotifyTypeError', type);
            this.handleErrorType();
            return '';
          }
        }
      },
      joinProductSuccessNotify(id, type) {
        const canNotify = window.joinProductSuccess && typeof window.joinProductSuccess === 'function';
        if (canNotify) {
          window.joinProductSuccess({ targetId: id, targetType: type });
        }
      },
      async fetchData(sn) {
        const data = await getNotifyInfo(sn);
        this.joinProductSuccessNotify(data.product.id, data.product.type);
        const res = this.fetchPageType(data.product.type);
        if (res === 'millionVipPreSale') {
          projectJump({
            name: 'MillionReadVipPreSaleDetail',
            params: { id: data.product.id },
          }, 1);
          return;
        }
        const info = await getRequiredUserInfoPageStatus('notify');
        if (res === 'PayNotifyMillionReadVip' && info.status === 'needShow') {
          projectJump({
            name: 'MillionReadRequiredInfo',
          });
          return;
        }
        if (res === 'OrderDetail') {
          const route = { name: 'OrderDetail', params: { sn } };
          this.$router.replace(route);
          return;
        }
        if (data.millionReadExperience && res === 'PayNotifyMillionReadVip') {
          this.currentView = 'PayNotifyMillionReadExperienceVip';
        } else {
          this.currentView = res;
        }
        this.pageData = data;
      },
      handleErrorType() {
        // 类型错误则跳转首页或我的订单
        this.$dialog.alert({ message: '订单正在处理，请稍后再试' }).then(() => {
          const auth = getAuth();
          let route = { name: 'Home' };
          if (auth && auth !== '') {
            route = { name: 'MyOrder' };
          }
          this.$router.replace(route);
        });
      },
    },
    created() {
      this.fetchData(this.$route.params.sn);
    },
    beforeRouteUpdate(to, from, next) {
      const { sn } = to.params;
      this.fetchData(sn);
      next();
    },
  };
</script>
